import React from 'react'
import ReactCountUp from 'react-countup'

interface CountUpProps {
  start?: number
  to?: number
  duration?: number
  decimals?: number
}

const CountUp: React.FC<CountUpProps> = ({ start = 0, to = 0, duration = 2.5, decimals }) => (
  <ReactCountUp
    start={start}
    end={to}
    delay={0}
    duration={duration}
    decimals={decimals}
    useEasing={false}
    separator=','
  >
    {({ countUpRef }) => <span ref={countUpRef} />}
  </ReactCountUp>
)

export default CountUp

